var config = require("../config.js");
var UTILS = require("./utils.js");
var ahk = require("../../antihackkey.json");
module.exports = {
  ahNum: 0,
  socket: null,
  connected: false,
  socketId: -1,
  sendQueue: [],
  trackPacketStats: false,
  ingressPacketCount: 0,
  ingressDataSize: 0,
  egressPacketCount: 0,
  egressDataSize: 0,
  connect(url, callback, events) {
    if (!this.socket) {
      this.events = events;

      var m = config.enableHttps ? "wss:" : "ws:";
      try {
        if (url.startsWith("http://")) {
          url = url.slice(7);
        } else if (url.startsWith("https://")) {
          url = url.slice(8);
        }
        var p = false;
        var q = m + url;
        this.socket = new WebSocket(q);
        this.socket.binaryType = "arraybuffer";
        this.socket.onmessage = (u) => {
          if (this.trackPacketStats) {
            this.ingressPacketCount++;
            this.ingressDataSize += u.data.byteLength;
          }
          var [v, w, x] = UTILS.decodePacket(u.data);
          if (w == "io-init") {
            this.socketId = x[0];
          } else if (w == "cpt") {
            this._showCaptcha();
          } else if (w == "cptR") {
            this._captchaComplete();
          } else {
            if (w == "error") {
              this._hideCaptcha();
            }
            this._dispatchEvent(w, x);
          }
        };
        this.socket.onopen = () => {
          this.connected = true;
          callback();
          for (let u of this.sendQueue) {
            this.send(u[0], ...u[1]);
          }
        };
        this.socket.onclose = () => {
          this.connected = false;
          if (!p) {
            callback("Disconnected. Try connecting to another server.");
          }
        };
        this.socket.onerror = (u) => {
          p = true;
          console.error("Socket error", u);
          callback("Socket error");
        };
      } catch (u) {
        console.error("Socket connection error:", u);
        callback(u);
      }
    }
  },
  _dispatchEvent(label, array) {
    if (this.events[label]) {
      this.events[label].apply(undefined, array);
    } else {
      console.error("Received unregistered event", label);
    }
  },
  send(label, ...data) {
    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      const readyState = this.socket ? this.socket.readyState : "no-socket";
      console.warn("Socket sending on socket not open yet", readyState);
      this.sendQueue.push([label, data]);
      return;
    }
    if (label != "cptR") {
      this.ahNum = UTILS.rotateAhNum(this.ahNum, ahk);
    }
    var encoded = UTILS.encodeNetworkMessage(
      UTILS.serializeNetworkMessage(label, ...data),
      this.ahNum,
    );
    this.socket.send(encoded);
    if (this.trackPacketStats) {
      this.egressPacketCount++;
      this.egressDataSize += encoded.byteLength;
    }
  },
  socketReady() {
    return this.socket && this.connected;
  },
  resetPacketTally() {
    this.ingressPacketCount = 0;
    this.ingressDataSize = 0;
    this.egressPacketCount = 0;
    this.egressDataSize = 0;
  },
  close() {
    if (this.socket) {
      this.socket.close();
    }
  },
  captchaHolder: null,
  _showCaptcha() {
    if (this.captchaHolder != null) {
      console.warn("Already showing captcha");
      return;
    }
    if (!window.hcaptcha || !window.hcaptchaReady) {
      console.warn("Hcaptcha not loaded yet or not ready yet");
      setTimeout(this._showCaptcha.bind(this), 1000);
      return;
    }
    this.captchaHolder = document.createElement("div");
    this.captchaHolder.id = "captcha-holder";
    this.captchaHolder.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    this.captchaHolder.style.zIndex = 999999;
    this.captchaHolder.style.position = "fixed";
    this.captchaHolder.style.top = "0";
    this.captchaHolder.style.left = "0";
    this.captchaHolder.style.bottom = "0";
    this.captchaHolder.style.right = "0";
    this.captchaHolder.style.pointerEvents = "all";
    document.body.appendChild(this.captchaHolder);
    this.captchaModal = document.createElement("div");
    this.captchaModal.style.backgroundColor = "white";
    this.captchaModal.style.zIndex = 999999;
    this.captchaModal.style.position = "fixed";
    this.captchaModal.style.top = "50%";
    this.captchaModal.style.left = "50%";
    this.captchaModal.style.transform = "translate(-50%, -50%)";
    this.captchaModal.style.padding = "20px";
    this.captchaModal.style.borderRadius = "6px";
    this.captchaModal.style.boxShadow = "0px 9px 0px 0px #a6a6a6";
    this.captchaModal.style.width = "450px";
    this.captchaModal.style.display = "flex";
    this.captchaModal.style.textAlign = "center";
    this.captchaModal.style.flexDirection = "column";
    this.captchaModal.style.justifyContent = "center";
    this.captchaModal.style.alignItems = "center";
    this.captchaModal.style.pointerEvents = "all";
    this.captchaHolder.appendChild(this.captchaModal);
    let j = document.createElement("div");
    j.style.fontSize = "32px";
    j.style.textTransform = "uppercase";
    j.style.marginBottom = "10px";
    j.textContent = "Security Challenge";
    this.captchaModal.appendChild(j);
    let k = document.createElement("div");
    k.style.color = "rgba(0, 0, 0, 0.6)";
    k.style.fontSize = "20px";
    k.style.marginBottom = "10px";
    k.textContent = "Please complete the security challenge to continue";
    this.captchaModal.appendChild(k);
    let l = document.createElement("div");
    this.captchaModal.appendChild(l);
    window.hcaptchaCallback = (m) => {
      this.send("cptR", m);
    };
    window.hcaptchaErrorCallback = (m) => {
      console.error("Hcaptcha error", m);
      this._hideCaptcha();
      this._dispatchEvent("error", ["CAPTCHA FAILED"]);
      this.close();
    };
    window.hcaptchaExpiredCallback = () => {
      this._hideCaptcha();
      this._dispatchEvent("error", ["CAPTCHA EXPIRED"]);
      this.close();
    };
    window.hcaptcha.render(l, {
      sitekey: "60a46f6a-e214-4aa8-b4df-4386e68dfde4",
      theme: "dark",
      callback: "hcaptchaCallback",
      "error-callback": "hcaptchaErrorCallback",
      "expired-callback": "hcaptchaExpiredCallback",
    });
  },
  _captchaComplete() {
    this._hideCaptcha();
  },
  _hideCaptcha() {
    if (this.captchaHolder) {
      this.captchaHolder.remove();
      this.captchaHolder = null;
      window.hcaptchaCallback =
        window.hcaptchaErrorCallback =
        window.hcaptchaExpiredCallback =
          null;
    }
  },
};
